// extracted by mini-css-extract-plugin
export default {"sheet":"SheetPreview-module__sheet__oLC4U","table":"SheetPreview-module__table__txSkt","cell":"SheetPreview-module__cell__07pA9"};